<template lang="pug">
div(
  v-if="!isPseudoAgent"
  class="c-avatar"
  :class="[containerClass]"
)
  div(class="c-avatar__img" :class="[imgColorClass]")
    BLBPicture(v-if="isBotAgent" :src="displayedIcon.icon" :title="nick" data-testid="acha-avatar")
    BlIconAv(v-else :icon="displayedIcon.icon" :color="displayedIcon.color" data-testid="agent-user-avatar")
</template>

<script>
import BlIconAv from '@bukalapak/bazaar-visual/dist/components/BlIconAv';
import IcoHeadset from '@bukalapak/bazaar-visual/dist/components/IcoHeadset';
import IcoUser from '@bukalapak/bazaar-visual/dist/components/IcoUser';
import BLBPicture from '~/components/shared/BLBPicture';

export default {
  name: 'Avatar',
  components: {
    BlIconAv,
    BLBPicture,
  },
  props: {
    nick: {
      type: String,
      required: true,
      default: 'visitor',
    },
  },
  computed: {
    /**
     * Checks if the message is sent from the livechat as agent
     * @returns {boolean}
     */
    isPseudoAgent() {
      return ['agent', 'greeting'].includes(this.nick);
    },

    /**
     * Determines if it is bot agent by seeing `nick`
     * @returns {boolean}
     */
    isBotAgent() {
      return ['agent:trigger', 'gpt'].includes(this.nick);
    },

    /**
     * Determines if it is visitor by seeing `nick`
     * @returns {boolean}
     */
    isVisitor() {
      return this.nick === 'visitor';
    },

    /**
     * Checks if the message is sent by a real agent from the Zopim Chat Dashboard
     * @returns {boolean}
     */
    isRealAgent() {
      return !this.isPseudoAgent && !this.isBotAgent && !this.isVisitor;
    },

    /**
     * @returns {string}
     */
    containerClass() {
      if (this.isVisitor) return 'c-avatar--visitor';
      return 'c-avatar--agent';
    },

    /**
     * @returns {string}
     */
    imgColorClass() {
      if (!this.isVisitor) {
        if (this.isBotAgent) return 'c-avatar__img--blue';
        return 'c-avatar__img--maroon';
      }
      return 'c-avatar__img--gray';
    },

    /**
     * @returns {object}
     */
    displayedIcon() {
      if (!this.isVisitor) {
        if (this.isBotAgent) return { icon: '/images/mitra-chat/acha_avatar.png' };
        return {
          icon: IcoHeadset,
          color: '#F7F7F7',
        };
      }
      return {
        icon: IcoUser,
        color: '#2E2E2E',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.c-avatar {
  width: 100%;
  display: flex;

  &--visitor {
    justify-content: flex-end;
  }
  &--agent {
    justify-content: flex-start;
  }

  &__img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;

    &--gray {
      background-color: $background-low;
    }
    &--maroon {
      background-color: #e31e52;
    }
    &--blue {
      background-color: $background-informational-03;
    }
  }
}
</style>
